import { onMounted, onUnmounted, ref } from 'vue';

const useCounter = (givenDate: Date, timeLimit: number = 30) => {
  const minutes = ref<number>(0);
  const seconds = ref<number>(0);

  const endDate = new Date(givenDate.getTime() + timeLimit * 60 * 1000);

  const calculateTimeRemaining = () => {
    const now = new Date().getTime();
    const timeRemaining = endDate.getTime() - now;

    if (timeRemaining <= 0) {
      minutes.value = 0;
      seconds.value = 0;
      return;
    }

    minutes.value = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
    seconds.value = Math.floor((timeRemaining % (1000 * 60)) / 1000);
  };

  let timerInterval: ReturnType<typeof setInterval>;

  onMounted(() => {
    calculateTimeRemaining(); // Initializing the timer
    timerInterval = setInterval(() => {
      calculateTimeRemaining();
    }, 1000);
  });

  onUnmounted(() => {
    clearInterval(timerInterval); // Cleaning up the interval
  });

  return { minutes, seconds };
};

export default useCounter;
